import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  intercept(req : any,next:any ) {
     
    let tokenizedReq = req.clone({
      setHeaders : {
        'Authorization':`Bearer ${localStorage.getItem("token")}`,
         'Accept': 'application/json',
      }
    })
    return next.handle(tokenizedReq)
  }
}
